import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LogoutUI } from "./LogoutUI";
import { CallbackUI } from "./CallbackUI";
import { MagicLinkHandler } from "./MagicLinkHandler";
import { NativeOpenInWebHandler } from "./NativeOpenInWebHandler";

const LocationWrapper = (Component: React.ComponentType<any>) => {
  const location = window.location;
  return <Component location={location} />;
};

export const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/auth/callback" element={LocationWrapper(CallbackUI)} />
      <Route
        path="/auth/ml"
        element={LocationWrapper(NativeOpenInWebHandler)}
      />
      <Route path="/auth/sml" element={LocationWrapper(MagicLinkHandler)} />
      <Route path="/logout" element={LocationWrapper(LogoutUI)} />
    </Routes>
  </BrowserRouter>
);
